import { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import StudiesList from "./StudiesList";
// import LogoutContainer from "../Layout/LogoutContainer";
import { HeaderStyle } from "../Common/styles/header";
import { useAppSelector } from "../../Redux/hooks";
import { platformAdminPermissions } from "../../utils/roles";

const Studies = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { platformPermissions } = useAppSelector((state) => state.user);
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.createStudy),
    [platformPermissions]
  );

  return (
    <>
      <Box
        sx={{
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        {/* <Box sx={{ ml: "auto" }}>
          <AiSearch />
        </Box> */}
        {/* <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box> */}
      </Box>
      <Box sx={HeaderStyle}>
        <Typography fontWeight="medium" color="text.primary">
          My Studies
        </Typography>

        {canEdit && (
          <Box sx={{ ml: "auto" }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setOpenDrawer(true)}
            >
              New Study
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 3, height: "calc(100vh - 132px)", overflow: "auto" }}>
        <StudiesList
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          canEdit={canEdit}
          type="my-studies"
        />
      </Box>
    </>
  );
};

export default Studies;
